import React, { useState, useEffect, useRef } from "react";
import logo from "../../assets/Logo.webp";
import successIcon from "../../assets/Form/success.png";
import tyBuildings from "../../assets/Form/tybuildings.png";
import tyBuildingsMobile from "../../assets/Form/tybuildingsmobile.png";
import callIcon from "../../assets/Form/call.png";
import womanDepo from "../../assets/Form/womanmandepo.png";
import wavesImage from "../../assets/Form/waves.png";
import caseNoteIcon from "../../assets/Form/casenote.png";
import attorneyCallIcon from "../../assets/Form/attorneycall.png";
import compensationIcon from "../../assets/Form/compensationdollar.png";
import wavesMobile from "../../assets/Form/wavesmobile.png";
import ozempicInjection from "../../assets/Form/ozempicinjection.png";
import womanCry from "../../assets/Form/womancry.png";
import ai from "../../assets/Form/ai.svg";
import human from "../../assets/Form/human.svg";
import aiblue from "../../assets/Form/ai-blue.svg";
import humanblue from "../../assets/Form/human-blue.svg";
import cloud from "../../assets/Form/cloud.svg";
import send from "../../assets/Form/send.svg";
import newlanderimg2 from "../../assets/Form/newlanderimg2.png";
import phoneicon from "../../assets/Form/phoneicon.svg"
import {
  OzempicLawsuitSendAdminEmailE,
  OzempicLawsuitSendUserEmail,
} from "../../emailService2";
import {
  buildAdvancedMatching,
  ensureMetaPixel,
  normalizeEmail,
  normalizePhone,
  isValidEmail,
  isValidPhoneDigits,
  trackEventWithUserData,
} from "../../utils/metaPixel";
import { LEAD_GENERATION_VERTICALS } from "../Lawsuits/constant";
const MAX_UPLOAD_SIZE_MB = 3;
const MAX_DOCUMENTS = 10;
const HUMAN_AGENT_HOURS = "10 AM - 6 PM CST";
const AI_AGENT_PHONE = "+18148884278";
const HUMAN_AGENT_PHONE = "+18663760014";
const DOCUMENT_UPLOAD_API_BASE =
  "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/upload-document";

/**
 * DepoProveraLawsuit Component with Full Backend Integration
 *
 * BACKEND FEATURES INTEGRATED:
 * - Meta Pixel tracking with advanced matching
 * - Google Analytics conversion tracking
 * - CRM submission
 * - Retell CRM submission
 * - EmailJS integration
 * - TrustedForm tracking
 * - Ad tracking parameters (gclid, gbraid, wbraid)
 */

const ThankYouPage = ({ selectedCallbackNumber, contactPreferenceLabel }) => (
  <div className="relative hidden h-screen w-full overflow-hidden bg-white md:block">
    <div className="flex justify-center pt-10">
      <img src={logo} alt="Be With Law" className="h-9" />
    </div>

    <div className="relative z-10 mt-[90px] flex flex-col items-center px-6 pb-[220px] text-center">
      <div className="mb-6 flex h-[96px] w-[96px] items-center justify-center rounded-full">
        <img src={successIcon} alt="Success" className="h-24 w-24" />
      </div>

      <h1 className="mb-4 text-[26px] font-bold text-[#162766]">
        Thank you for sharing your story.
      </h1>

      <p className="max-w-[560px] text-[14px] leading-relaxed text-[#4B5563]">
        We received your intake and document details. Your selected follow-up
        option is {contactPreferenceLabel || "the next available agent"}.
      </p>

      <div className="mt-6 flex justify-center">
  <a
    href={`tel:${selectedCallbackNumber}`}
    className="
      flex items-center gap-3
      rounded-full
      bg-[#FFD23F]
      px-5 py-3
      shadow-md
      hover:shadow-lg
      transition-all duration-200
    "
  >
    {/* Phone Icon Circle */}
   <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#162766]">
  <img
    src={phoneicon}
    alt="phone icon"
    className="h-[16px] w-[16px]"
  />
</div>

    {/* Text Section */}
    <div className="flex flex-col leading-tight text-left">
      <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#162766]">
        Call Now For A Free
      </span>

      <span className="text-[18px] font-bold text-[#162766]">
        {selectedCallbackNumber}
      </span>
    </div>
  </a>
</div>

      <div className="mt-8 flex gap-3 text-[13px] text-[#162766]">
        <a
          href="/Disclaimer"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold hover:text-blue-800"
        >
          Disclaimer
        </a>
        <span>|</span>
        <a
          href="/PrivacyPolicy"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold hover:text-blue-800"
        >
          Privacy Policy
        </a>
      </div>
    </div>

    <div className="absolute bottom-0 left-0 z-0 w-full">
      <img src={tyBuildings} alt="Buildings" className="w-full" />
    </div>
  </div>
);

const MobileThankYou = ({ selectedCallbackNumber, contactPreferenceLabel }) => (
  <div className="relative min-h-screen w-full overflow-hidden bg-white md:hidden">
    <div className="flex justify-center pt-10">
      <img src={logo} alt="Be With Law" className="h-8" />
    </div>

    <div className="relative z-10 mt-20 px-6 pb-48 text-center">
      <div className="mx-auto mb-6 flex h-[88px] w-[88px] items-center justify-center rounded-full bg-[#162766]">
        <svg width="42" height="32" viewBox="0 0 42 32" fill="none">
          <path
            d="M2 18L14 30L40 2"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h2 className="mb-4 text-[28px] font-bold text-[#162766]">
        Thank you for
        <br />
        sharing your story.
      </h2>

      <p className="text-[16px] leading-[22px] text-[#4B5563]">
        We received your intake and document details. Your selected follow-up
        option is {contactPreferenceLabel || "the next available agent"}.
      </p>

      <div className="mx-auto mt-8 max-w-[280px] rounded-2xl border border-[#D7DBEA] bg-[#F7F9FD] px-5 py-4 text-center shadow-sm">
        <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-[#72809F]">
          Call This Number
        </p>
        <a
          href={`tel:${selectedCallbackNumber}`}
          className="mt-2 block text-[28px] font-bold text-[#162766]"
        >
          {selectedCallbackNumber}
        </a>
      </div>

      <div className="mt-20 flex justify-center gap-3 text-[13px] text-[#162766]">
        <a
          href="/Disclaimer"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold hover:text-blue-800"
        >
          Disclaimer
        </a>
        <span>|</span>
        <a
          href="/PrivacyPolicy"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold hover:text-blue-800"
        >
          Privacy Policy
        </a>
      </div>
    </div>

    <img
      src={tyBuildingsMobile}
      alt="Buildings"
      className="absolute bottom-0 left-0 w-full"
    />
  </div>
);

const UploadZone = ({
  documents,
  uploadProgress,
  uploadError,
  onFileUpload,
  onRemoveDocument,
  fileInputRef,
}) => {
  return (
    <div className="space-y-4">
      {/* Upload Card (only when no files) */}
      {documents.length === 0 && (
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="
            w-full
            rounded-xl
            border
            border-dashed
            border-[#D6D9E4]
            bg-[#F3F4F7]
            px-6
            py-10
            text-center
            transition
            hover:border-[#162766]
          "
        >
          {/* Upload Icon */}
          <div className="flex justify-center mb-4">
            <img src={cloud} alt="Upload" className="w-10 h-10" />
          </div>

          {/* Title */}
          <p className="text-[16px] font-semibold text-[#1E2433]">
            Upload Supporting Documents
          </p>

          {/* Description */}
          <p className="mt-2 text-[13px] text-[#6B7280] leading-[18px]">
            Diagnosis reports, medical records, <br />
            prescriptions, treatment history
          </p>

          {/* Yellow Add Button */}
          <div className="mt-5 flex justify-center">
            <div
              className="
                w-[36px]
                h-[36px]
                flex
                items-center
                justify-center
                rounded
                bg-[#FFD400]
                text-[#1E2433]
                text-[18px]
                font-bold
                shadow-sm
              "
            >
              +
            </div>
          </div>

          {/* Footer Text */}
          <p className="mt-5 text-[12px] text-[#8A90A5]">
            Accepted files: PDF, JPG, PNG (Max {MAX_UPLOAD_SIZE_MB}MB per file)
          </p>
        </button>
      )}

      {/* Hidden File Input */}
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".pdf,.jpg,.jpeg,.png"
        className="hidden"
        onChange={(event) => {
          void onFileUpload(event.target.files);
        }}
      />

      {/* Upload Progress */}
      {uploadProgress > 0 && uploadProgress < 100 && (
        <div>
          <div className="h-2 overflow-hidden rounded-full bg-[#E6EAF4]">
            <div
              className="h-full rounded-full bg-[#162766] transition-all"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>

          <p className="mt-2 text-[11px] text-[#5A627A]">
            Uploading files... {uploadProgress}%
          </p>
        </div>
      )}

      {/* Upload Error */}
      {uploadError && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-[12px] text-red-600">
          {uploadError}
        </div>
      )}

      {/* Uploaded Files List */}
      {documents.length > 0 && (
        <div className="space-y-3">
          {/* File List */}
          <div className="space-y-2">
            {documents.map((document, index) => (
              <div
                key={`${document.url || document.name}-${index}`}
                className="
                  flex
                  items-center
                  justify-between
                  rounded-xl
                  bg-[#ECECF1]
                  px-4
                  py-3
                "
              >
                {/* Left Section */}
                <div className="flex items-center gap-3 min-w-0">
                  {/* PDF Badge */}
                  <div
                    className="
                      px-2.5
                      py-1
                      rounded-md
                      bg-white
                      text-[11px]
                      font-semibold
                      text-[#6B7280]
                      shadow-sm
                    "
                  >
                    PDF
                  </div>

                  {/* File Name */}
                  <p className="truncate text-[13px] font-medium text-[#1E2433]">
                    {document.name}
                  </p>
                </div>

                {/* Remove Button */}
                <button
                  type="button"
                  onClick={() => onRemoveDocument(index)}
                  className="
                    ml-3
                    w-[28px]
                    h-[28px]
                    flex
                    items-center
                    justify-center
                    rounded-full
                    bg-[#E4E6EF]
                    text-[#5A627A]
                    text-[14px]
                    font-bold
                    transition
                    hover:bg-[#D7DBEA]
                  "
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Add More Button */}
          {documents.length < MAX_DOCUMENTS && (
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="
                flex
                items-center
                gap-3
                rounded-xl
                bg-[#ECECF1]
                px-4
                py-3
                text-[13px]
                font-medium
                text-[#1E2433]
                transition
                hover:bg-[#E2E5F0]
              "
            >
              <div
                className="
                  w-[28px]
                  h-[28px]
                  flex
                  items-center
                  justify-center
                  rounded
                  bg-[#FFD400]
                  font-bold
                "
              >
                +
              </div>
              Add more documents
            </button>
          )}
        </div>
      )}
    </div>
  );
};

const ContactOption = ({
  title,
  description,
  value,
  selectedValue,
  onSelect,
  disabled = false,
}) => {
  const selected = selectedValue === value;

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => !disabled && onSelect(value)}
      className={`
        group
        w-full
        rounded-lg
        border
        p-4
        text-left
        flex items-center gap-4
        transition-all duration-200

        ${
          disabled
            ? `
              cursor-not-allowed
              border-[#E5E7EB]
              bg-[#F3F4F6]
              opacity-70
            `
            : selected
            ? `
              border-[#1E2A6A]
              bg-[#1E2A6A]
            `
            : `
              border-[#D7DBEA]
              bg-[#F5F6FA]
              hover:bg-[#1E2A6A]
              hover:border-[#1E2A6A]
            `
        }
      `}
    >
      {/* ICON BOX */}
      <div
        className={`
          w-[64px] h-[64px]
          flex items-center justify-center
          rounded-xl shrink-0
          transition-all duration-200

          ${
            disabled
              ? "bg-[#D1D5DB]"
              : selected
              ? "bg-[#FFD21E]"
              : "bg-[#1E2A6A] group-hover:bg-[#FFD21E]"
          }
        `}
      >
        {/* Default Icon */}
        <img
          src={value === "human" ? human : ai}
          alt={title}
          className={`
            w-6 h-6
            ${
              disabled
                ? "block opacity-60"
                : selected
                ? "hidden"
                : "block group-hover:hidden"
            }
          `}
        />

        {/* Hover / Selected Icon */}
        {!disabled && (
          <img
            src={value === "human" ? humanblue : aiblue}
            alt={title}
            className={`
              w-6 h-6
              ${selected ? "block" : "hidden group-hover:block"}
            `}
          />
        )}
      </div>

      {/* TEXT */}
      <div>
        <p
          className={`
            text-[15px]
            font-semibold
            transition-colors

            ${
              disabled
                ? "text-[#9CA3AF]"
                : selected
                ? "text-white"
                : "text-[#191B37] group-hover:text-white"
            }
          `}
        >
          {title}
        </p>

        <p
          className={`
            mt-1
            text-[13px]
            transition-colors

            ${
              disabled
                ? "text-[#9CA3AF]"
                : selected
                ? "text-[#D6DAE6]"
                : "text-[#5A627A] group-hover:text-[#D6DAE6]"
            }
          `}
        >
          {description}
        </p>
      </div>
    </button>
  );
};

const NewMedicalOzempicLawsuitB = () => {
  // Meta Pixel ID
  const META_PIXEL_ID = "1244345311191543"; //last one : 1409965080153428

  // Refs for tracking
  let initialLandingUrl = useRef(null);
  const adTrackingRef = useRef({
    gclid: null,
    gbraid: null,
    wbraid: null,
  });
  const fileInputRef = useRef(null);

  const [showThankYou, setShowThankYou] = useState(false);
  const [showCallPopup, setShowCallPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [documents, setDocuments] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState("");
  const [contactPreference, setContactPreference] = useState(null);
  const [reviewFilesConsent, setReviewFilesConsent] = useState(false);
  const [texasTimeStatus, setTexasTimeStatus] = useState({
    isOpen: false,
    currentTimeLabel: "",
  });

  // ================= PARTIAL CAPTURE STATE =================
  const [leadId, setLeadId] = useState(null);
  const [submissionId, setSubmissionId] = useState(null);
  const [earlySent, setEarlySent] = useState(false);

  const earlyLeadLock = useRef(false);
  const partialLeadUpdateLock = useRef(false);
  const lastPartialSnapshotRef = useRef(null);
  const finalSubmitLock = useRef(false);
  const hasFinalSubmittedRef = useRef(false);

  const generateSessionId = () => {
    return `CR_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  };

  const [uniqueSessionId] = useState(generateSessionId);

  // Form state for desktop
  const [desktopFormData, setDesktopFormData] = useState({
    fullName: "",
    phone: "+1 ",
    email: "",
    q1: "",
    q2: "",
    q3: "",
    consent: false,
  });

  // Form state for mobile
  const [mobileFormData, setMobileFormData] = useState({
    fullName: "",
    phone: "+1 ",
    email: "",
    q1: "",
    q2: "",
    q3: "",
    consent: false,
  });

  // Error state
  const [desktopErrors, setDesktopErrors] = useState({});
  const [mobileErrors, setMobileErrors] = useState({});
  const [desktopTouched, setDesktopTouched] = useState({});
  const [mobileTouched, setMobileTouched] = useState({});

  // ========== BACKEND HELPER FUNCTIONS ==========

  const PARTIAL_CRM_API_URL =
    "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata";
  const FINAL_STEPPER_LEAD_API_URL =
    "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata/stepper-lead";
  // const PARTIAL_CRM_API_URL =
  //   "http://localhost:3000/api/submitformdata";
  // const FINAL_STEPPER_LEAD_API_URL =
  //   "http://localhost:3000/api/submitformdata/stepper-lead";


  const getSourceUrl = () => {
    if (typeof window === "undefined") return "Unknown";
    if (!initialLandingUrl.current) {
      initialLandingUrl.current = window.location.href;
    }
    return initialLandingUrl.current;
  };

  const getIPAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Failed to get IP address:", error);
      return "IP address not available";
    }
  };

  const normalizePhoneDigits = (phone) => {
    return phone.replace(/\D/g, "").slice(0, 10);
  };

  const formatPhoneInput = (value) => {
    let digits = value.replace(/\D/g, "");

    // Remove leading 1 only if pasted country code
    if (digits.length === 11 && digits.startsWith("1")) {
      digits = digits.slice(1);
    }

    // Limit to 10 digits
    digits = digits.slice(0, 10);

    let formatted = "";

    if (digits.length > 0) {
      formatted += `(${digits.substring(0, 3)}`;
    }

    if (digits.length >= 4) {
      formatted += `) ${digits.substring(3, 6)}`;
    }

    if (digits.length >= 7) {
      formatted += `-${digits.substring(6, 10)}`;
    }

    return formatted;
  };

  const getUSTimezone = (tz) => {
    if (!tz) return "unknown";

    // Eastern
    if (
      tz.includes("New_York") ||
      tz.includes("Detroit") ||
      tz.includes("Indiana")
    )
      return "ET";

    // Central
    if (tz.includes("Chicago") || tz.includes("Menominee")) return "CT";

    // Mountain
    if (tz.includes("Denver") || tz.includes("Boise") || tz.includes("Phoenix"))
      return "MT";

    // Pacific
    if (tz.includes("Los_Angeles")) return "PT";

    // Alaska
    if (tz.includes("Anchorage") || tz.includes("Juneau")) return "AK";

    // Hawaii
    if (tz.includes("Honolulu")) return "HT";

    return "other";
  };

  const getTexasTimeStatus = () => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago",
      weekday: "short",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    const parts = formatter.formatToParts(new Date());
    const hour = Number(parts.find((part) => part.type === "hour")?.value || 0);
    const weekday =
      parts.find((part) => part.type === "weekday")?.value?.toLowerCase() || "";
    const dayPeriod =
      parts.find((part) => part.type === "dayPeriod")?.value?.toLowerCase() ||
      "am";

    const normalizedHour = dayPeriod === "pm" && hour !== 12 ? hour + 12 : hour;
    const safeHour = dayPeriod === "am" && hour === 12 ? 0 : normalizedHour;
    const isWeekday = !["sat", "sun"].includes(weekday);

    return {
      isOpen: isWeekday && safeHour >= 10 && safeHour < 18,
      currentTimeLabel: formatter.format(new Date()),
    };
  };

  const getTrustedFormData = () => {
    return new Promise((resolve) => {
      // Check both desktop and mobile forms
      const certUrl =
        document.getElementById("xxTrustedFormCertUrl")?.value ||
        document.getElementById("xxTrustedFormCertUrl_mobile")?.value;

      const tokenUrl =
        document.getElementById("xxTrustedFormCertToken")?.value ||
        document.getElementById("xxTrustedFormCertToken_mobile")?.value;

      const pingUrl =
        document.getElementById("xxTrustedFormPingUrl")?.value ||
        document.getElementById("xxTrustedFormPingUrl_mobile")?.value;

      if (!certUrl) {
        setTimeout(() => {
          const retryCertUrl =
            document.getElementById("xxTrustedFormCertUrl")?.value ||
            document.getElementById("xxTrustedFormCertUrl_mobile")?.value;
          const retryTokenUrl =
            document.getElementById("xxTrustedFormCertToken")?.value ||
            document.getElementById("xxTrustedFormCertToken_mobile")?.value;
          const retryPingUrl =
            document.getElementById("xxTrustedFormPingUrl")?.value ||
            document.getElementById("xxTrustedFormPingUrl_mobile")?.value;

          resolve({
            certId: retryCertUrl,
            tokenUrl: retryTokenUrl,
            pingUrl: retryPingUrl,
          });
        }, 500);
      } else {
        resolve({
          certId: certUrl,
          tokenUrl: tokenUrl,
          pingUrl: pingUrl,
        });
      }
    });
  };

  const getContactPreferenceLabel = (value) => {
    if (value === "ai") return "24/7 AI Agent";
    if (value === "human") return `Human Agent (${HUMAN_AGENT_HOURS})`;
    return "";
  };

  const getSelectedCallbackNumber = (value) =>
    value === "human" ? HUMAN_AGENT_PHONE : AI_AGENT_PHONE;

  const openPhoneCallScreen = (phoneNumber) => {
    if (!phoneNumber || typeof window === "undefined") {
      return;
    }

    window.location.href = `tel:${phoneNumber}`;
  };

  const buildStepperLeadData = ({
    currentLeadId = leadId,
    fullName,
    phone,
    email = "",
    q1 = "",
    q2 = "",
    q3 = "",
    consent = false,
    nextDocuments = documents,
    nextContactPreference = contactPreference,
    nextReviewFilesConsent = reviewFilesConsent,
    trustedFormData,
    ipAddress,
    timezone,
  }) => {
    const normalizedPhone = normalizePhoneDigits(phone);
    const cleanName = fullName.trim();
    const normalizedEmail = validateEmail(email) ? email.trim() : "";
    const normalizedDocumentUrls = nextDocuments
      .map((document) => document.url)
      .filter(Boolean);

    return {
      ...(currentLeadId ? { leadId: currentLeadId } : {}),
      fullName: cleanName,
      name: cleanName,
      phone: normalizedPhone.length === 10 ? `+1${normalizedPhone}` : "",
      email: normalizedEmail,
      q1,
      q2,
      q3,
      consent,
      reviewFilesConsent: Boolean(nextReviewFilesConsent),
      contactPreference: nextContactPreference,
      contactPreferenceLabel: getContactPreferenceLabel(nextContactPreference),
      hasContactPreference: Boolean(nextContactPreference),
      isFileSubmitted: normalizedDocumentUrls.length > 0,
      documentsCount: nextDocuments.length,
      submissionDate: new Date().toISOString(),
      currentStep,
      uniqueSessionId,
      pageSource: getSourceUrl(),
      trustedFormCertUrl: trustedFormData.certId,
      trustedFormPingUrl: trustedFormData.pingUrl,
      trustedFormToken: trustedFormData.tokenUrl,
      ipAddress,
      gclid: adTrackingRef.current.gclid,
      gbraid: adTrackingRef.current.gbraid,
      wbraid: adTrackingRef.current.wbraid,
      timezone,
    };
  };

  const buildPartialLeadSnapshot = (stepperLeadData) => {
    const {
      submissionDate,
      ipAddress,
      trustedFormCertUrl,
      trustedFormPingUrl,
      trustedFormToken,
      ...stableData
    } = stepperLeadData;

    return JSON.stringify(stableData);
  };

  const buildLeadRequestBody = ({ payload, finalSubmit = false }) => ({
    countryName: "USA",
    brandType: "Internal",
    brandName: "Project 6",
    websiteName: "Be With Law",
    formPath: "/ozempic-lawsuit-e",
    vertical: LEAD_GENERATION_VERTICALS.OZEMPIC,
    formname: "Ozempic Lawsuit lander E",
    isPartialSubmission: !finalSubmit,
    ...(finalSubmit ? { finalSubmit: true, deleteFromWebsiteLogs: true } : {}),
    data: payload,
  });

  const postStepperLead = async ({ payload, finalSubmit = false }) => {
    const requestBody = buildLeadRequestBody({ payload, finalSubmit });

    const res = await fetch(FINAL_STEPPER_LEAD_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  };

  const createPartialLead = async ({ payload }) => {
    const requestBody = buildLeadRequestBody({ payload });

    const res = await fetch(PARTIAL_CRM_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  };

  const updatePartialLead = async ({ leadId: currentLeadId, payload }) => {
    const requestBody = buildLeadRequestBody({ payload });

    const res = await fetch(`${PARTIAL_CRM_API_URL}/${currentLeadId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  };

  const finalizePartialLead = async ({ submissionId: currentSubmissionId, payload }) => {
    const requestBody = buildLeadRequestBody({
      payload,
      finalSubmit: true,
    });

    const res = await fetch(`${PARTIAL_CRM_API_URL}/${currentSubmissionId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  };

  const createEarlyLead = async ({
    fullName,
    phone,
    email = "",
    q1 = "",
    q2 = "",
    q3 = "",
    consent = false,
  }) => {
    const cleanName = fullName.trim();

    if ((leadId && submissionId) || earlySent || earlyLeadLock.current) {
      return leadId;
    }
    if (!cleanName || phone.length !== 10) return null;

    earlyLeadLock.current = true;

    try {
      const trustedFormData = await getTrustedFormData();
      const ipAddress = await getIPAddress();
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const partialData = buildStepperLeadData({
        fullName: cleanName,
        phone,
        email,
        q1,
        q2,
        q3,
        consent,
        trustedFormData,
        ipAddress,
        timezone,
      });
      let nextSubmissionId = submissionId;
      if (!nextSubmissionId) {
        const partialJson = await createPartialLead({ payload: partialData });
        nextSubmissionId = partialJson?.id || null;
      }

      const stepperJson = await postStepperLead({ payload: partialData });
      const nextLeadId = stepperJson?.leadId || stepperJson?.id || null;

      if (!nextLeadId) {
        throw new Error("Lead ID missing from stepper response");
      }

      if (nextSubmissionId) {
        setSubmissionId(nextSubmissionId);
      }
      setLeadId(nextLeadId);
      setEarlySent(true);
      lastPartialSnapshotRef.current = buildPartialLeadSnapshot({
        ...partialData,
        leadId: nextLeadId,
      });
      return nextLeadId;
    } catch (err) {
      console.error("Early Lead Failed:", err);
      earlyLeadLock.current = false;
      return null;
    }
  };

  const syncPartialLead = async ({
    nextFormData,
    nextDocuments = documents,
    nextContactPreference = contactPreference,
    nextReviewFilesConsent = reviewFilesConsent,
    currentLeadId = leadId,
  }) => {
    if (hasFinalSubmittedRef.current) {
      return;
    }

    const cleanName = nextFormData.fullName.trim();
    const normalizedPhone = normalizePhoneDigits(nextFormData.phone);

    if (!currentLeadId || !cleanName || normalizedPhone.length !== 10) {
      return;
    }

    if (partialLeadUpdateLock.current) {
      return;
    }

    try {
      partialLeadUpdateLock.current = true;
      const trustedFormData = await getTrustedFormData();
      const ipAddress = await getIPAddress();
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const partialData = buildStepperLeadData({
        currentLeadId,
        ...nextFormData,
        phone: normalizedPhone,
        nextDocuments,
        nextContactPreference,
        nextReviewFilesConsent,
        trustedFormData,
        ipAddress,
        timezone,
      });
      const partialSnapshot = buildPartialLeadSnapshot(partialData);

      if (lastPartialSnapshotRef.current === partialSnapshot) {
        return;
      }

      if (submissionId) {
        await updatePartialLead({
          leadId: submissionId,
          payload: partialData,
        });
      }

      await postStepperLead({
        payload: partialData,
      });

      lastPartialSnapshotRef.current = partialSnapshot;
    } catch (err) {
      console.error("Partial lead update failed:", err);
    } finally {
      partialLeadUpdateLock.current = false;
    }
  };

  const triggerEarlyLeadIfEligible = async (formData) => {
    const phone = normalizePhoneDigits(formData.phone);
    const fullName = formData.fullName.trim();

    if (!fullName || phone.length !== 10) {
      return null;
    }

    return createEarlyLead({
      fullName,
      phone,
      q1: formData.q1,
      q2: formData.q2,
      q3: formData.q3,
      consent: formData.consent,
      email: validateEmail(formData.email) ? formData.email : "",
    });
  };

  const syncEmailUpdateIfEligible = async (
    formData,
    currentLeadId = leadId,
  ) => {
    const email = formData.email.trim();

    if (!email || !validateEmail(email)) {
      return;
    }

    await syncPartialLead({
      nextFormData: formData,
      currentLeadId,
    });
  };

  const ensureLeadForForm = async (formData) => {
    let currentLeadId = leadId;

    if (!currentLeadId) {
      currentLeadId = await triggerEarlyLeadIfEligible(formData);
    }

    if (!currentLeadId) {
      console.error("No leadId found");
      return null;
    }

    await syncEmailUpdateIfEligible(formData, currentLeadId);

    return currentLeadId;
  };

  const submitFinalLead = async ({ currentLeadId, payload }) => {
    if (hasFinalSubmittedRef.current || finalSubmitLock.current) {
      return;
    }

    finalSubmitLock.current = true;

    try {
    const trustedFormData = await getTrustedFormData();
    const ipAddress = await getIPAddress();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const finalLeadData = buildStepperLeadData({
      currentLeadId,
      fullName: payload.fullName,
      phone: payload.phone,
      email: payload.email,
      q1: payload.q1,
      q2: payload.q2,
      q3: payload.q3,
      consent: payload.consent,
      nextDocuments: documents,
      nextContactPreference: payload.contactPreference,
      nextReviewFilesConsent: reviewFilesConsent,
      trustedFormData,
      ipAddress,
      timezone,
    });

      if (submissionId) {
        await finalizePartialLead({
          submissionId,
          payload: {
            ...finalLeadData,
            firstName: payload.fullName.split(" ")[0] || "",
            lastName: payload.fullName.split(" ").slice(1).join(" ") || "",
          },
        });
      }

      await postStepperLead({
        payload: {
          ...finalLeadData,
          firstName: payload.fullName.split(" ")[0] || "",
          lastName: payload.fullName.split(" ").slice(1).join(" ") || "",
        },
        finalSubmit: true,
      });

      hasFinalSubmittedRef.current = true;
    } finally {
      finalSubmitLock.current = false;
    }
  };

  // const saveToCRM = async ({ payload }) => {
  //   try {
  //     const ipAddress = await getIPAddress();
  //     const response = await fetch('https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         countryName: 'USA',
  //         brandType: "Internal",
  //         brandName: 'Project 6',
  //         websiteName: 'Be With Law',
  //         vertical: LEAD_GENERATION_VERTICALS.OZEMPIC,
  //         formPath: '/ozempic-lawsuit-e',
  //         formname: 'Ozempic Lawsuit lander E',
  //         data: {
  //           submissionDate: new Date().toLocaleString(),
  //           name: payload.fullName,
  //           firstName: payload.fullName.split(' ')[0] || '',
  //           lastName: payload.fullName.split(' ').slice(1).join(' ') || '',
  //           email: payload.email,
  //           phone: payload.phone,
  //           q1: payload.q1,
  //           q2: payload.q2,
  //           q3: payload.q3,
  //           injuryType: "Brain Tumor / Meningioma",
  //           trustedFormCertUrl: payload.certId,
  //           trustedFormPingUrl: payload.pingUrl,
  //           trustedFormToken: payload.tokenUrl,
  //           ip_address: ipAddress,
  //           page_source: getSourceUrl(),
  //           gclid: payload.gclid,
  //           gbraid: payload.gbraid,
  //           wbraid: payload.wbraid,
  //         }
  //       })
  //     });
  //     return response.ok;
  //   } catch (e) {
  //     console.error('CRM submission error:', e);
  //     return false;
  //   }
  // };

  // ========== VALIDATION FUNCTIONS ==========

  const validateEmail = (email) => {
    const normalizedEmail = normalizeEmail(email);
    return isValidEmail(normalizedEmail);
  };

  const validatePhone = (phone) => {
    const normalizedPhone = normalizePhone(phone, { defaultCountryCode: "1" });
    return isValidPhoneDigits(normalizedPhone);
  };

  const validateForm = (formData) => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.q1) {
      newErrors.q1 = "Please answer this question";
    }

    if (!formData.q2) {
      newErrors.q2 = "Please answer this question";
    }

    if (!formData.q3) {
      newErrors.q3 = "Please answer this question";
    }

    if (!formData.consent) {
      newErrors.consent = "You must agree to the terms to continue";
    }

    return newErrors;
  };

  const validateStepOne = (formData) => validateForm(formData);

  const validateStepTwo = () => {
    const newErrors = {};

    if (documents.length === 0) {
      newErrors.documents = "Please upload at least one document";
    }

    if (!reviewFilesConsent) {
      newErrors.reviewFilesConsent =
        "Please confirm before sending files for review";
    }

    if (!contactPreference) {
      newErrors.contactPreference = "Please choose a call option";
    }

    return newErrors;
  };

  const handleFileUpload = async (fileList) => {
    const files = Array.from(fileList || []);

    if (files.length === 0) {
      return;
    }

    if (documents.length + files.length > MAX_DOCUMENTS) {
      setUploadError(`You can upload up to ${MAX_DOCUMENTS} files.`);
      return;
    }

    const oversizedFile = files.find(
      (file) => file.size > MAX_UPLOAD_SIZE_MB * 1024 * 1024,
    );

    if (oversizedFile) {
      setUploadError(
        `${oversizedFile.name} exceeds the ${MAX_UPLOAD_SIZE_MB}MB limit.`,
      );
      return;
    }

    setUploadError("");
    setUploadProgress(10);

    try {
      const currentLeadId =
        await ensureLeadForForm(
          desktopFormData.fullName ? desktopFormData : mobileFormData,
        );

      if (!currentLeadId) {
        throw new Error("Lead creation failed before file upload.");
      }

      const uploadedDocuments = [];

      for (let index = 0; index < files.length; index += 1) {
        const file = files[index];
        const formPayload = new FormData();
        formPayload.append("file", file);

        const response = await fetch(
          `${DOCUMENT_UPLOAD_API_BASE}/upload/${currentLeadId}`,
          {
            method: "POST",
            body: formPayload,
          },
        );

        if (!response.ok) {
          throw new Error(await response.text());
        }

        const result = await response.json();
        const uploadedFile = result?.file || {};
        uploadedDocuments.push({
          id: uploadedFile.id || `${Date.now()}-${index}`,
          leadId: uploadedFile.leadId || currentLeadId,
          name: uploadedFile.name || file.name,
          size: uploadedFile.size ?? file.size,
          url: uploadedFile.url || "",
          blobName: uploadedFile.blobName || "",
          type: uploadedFile.type || file.type,
          uploadedAt: uploadedFile.uploadedAt || new Date().toISOString(),
        });

        setUploadProgress(
          Math.round(((index + 1) / files.length) * 100),
        );
      }

      const nextDocuments = [...documents, ...uploadedDocuments];
      setDocuments(nextDocuments);
      setUploadProgress(100);
      setDesktopErrors((current) => ({ ...current, documents: "" }));
      setMobileErrors((current) => ({ ...current, documents: "" }));

      await syncPartialLead({
        nextFormData: desktopFormData.fullName
          ? desktopFormData
          : mobileFormData,
        nextDocuments,
      });
    } catch (error) {
      console.error("Document upload failed:", error);
      setUploadError("Something went wrong while uploading your files.");
    } finally {
      window.setTimeout(() => setUploadProgress(0), 600);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleRemoveDocument = async (index) => {
    const documentToRemove = documents[index];

    if (!documentToRemove) {
      return;
    }

    const fallbackDocuments = documents.filter(
      (_, itemIndex) => itemIndex !== index,
    );
    const currentLeadId = leadId || documentToRemove.leadId;

    try {
      if (currentLeadId && documentToRemove.id) {
        const response = await fetch(
          `${DOCUMENT_UPLOAD_API_BASE}/documents/${currentLeadId}/${documentToRemove.id}`,
          {
            method: "DELETE",
          },
        );

        if (!response.ok) {
          throw new Error(await response.text());
        }

        const result = await response.json();
        setDocuments(
          Array.isArray(result?.documents) ? result.documents : fallbackDocuments,
        );
      } else {
        setDocuments(fallbackDocuments);
      }

      await syncPartialLead({
        nextFormData: desktopFormData.fullName
          ? desktopFormData
          : mobileFormData,
        nextDocuments: fallbackDocuments,
      });
    } catch (error) {
      console.error("Document delete failed:", error);
      setUploadError("Something went wrong while removing your file.");
    }
  };

  const handleNext = async (mode) => {
    const formData = mode === "desktop" ? desktopFormData : mobileFormData;
    const setTouched =
      mode === "desktop" ? setDesktopTouched : setMobileTouched;
    const setErrors = mode === "desktop" ? setDesktopErrors : setMobileErrors;

    setTouched({
      fullName: true,
      phone: true,
      email: true,
      q1: true,
      q2: true,
      q3: true,
      consent: true,
    });

    const newErrors = validateStepOne(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const currentLeadId = await ensureLeadForForm(formData);
    if (!currentLeadId) {
      return;
    }

    setCurrentStep(2);
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  // ========== FORM SUBMISSION HANDLERS ==========

  // const handleDesktopSubmit = async (e) => {
  //   e.preventDefault();

  //   setDesktopTouched({
  //     fullName: true,
  //     phone: true,
  //     email: true,
  //     q1: true,
  //     q2: true,
  //     q3: true,
  //     consent: true,
  //   });

  //   const newErrors = validateForm(desktopFormData);
  //   setDesktopErrors(newErrors);

  //   if (Object.keys(newErrors).length === 0) {
  //     setIsSubmitting(true);

  //     const trustedFormData = await getTrustedFormData();

  //     const payload = {
  //       ...desktopFormData,
  //       ...trustedFormData,
  //       gclid: adTrackingRef.current.gclid,
  //       gbraid: adTrackingRef.current.gbraid,
  //       wbraid: adTrackingRef.current.wbraid,
  //     };

  //     try {
  //       const sentToCrm = await saveToCRM({ payload });
  //       sendToRetellCRM({ payload });

  //       Promise.all([
  //         OzempicLawsuitSendAdminEmailE({ formData: payload }),
  //         OzempicLawsuitSendUserEmail({ formData: payload })
  //       ]).catch(err => {
  //         console.error("Email sending failed:", err);
  //       });

  //       if (sentToCrm) {
  //         setShowThankYou(true);

  //         // Track Lead event with advanced matching
  //         const userData = buildAdvancedMatching({
  //           email: payload.email,
  //           phoneNumber: payload.phone
  //         });
  //         trackEventWithUserData('CompleteRegistration', userData);

  //         // Google Ads conversion tracking
  //         if (window.gtag) {
  //           window.gtag('event', 'conversion', {
  //             send_to: 'AW-17927925652/dummy', //change it later
  //             value: 1.0,
  //             currency: 'USD'
  //           });
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error submitting form:', error);
  //     } finally {
  //       setIsSubmitting(false);
  //     }
  //   }
  // };

  // const handleMobileSubmit = async (e) => {
  //   e.preventDefault();

  //   setMobileTouched({
  //     fullName: true,
  //     phone: true,
  //     email: true,
  //     q1: true,
  //     q2: true,
  //     q3: true,
  //     consent: true,
  //   });

  //   const newErrors = validateForm(mobileFormData);
  //   setMobileErrors(newErrors);

  //   if (Object.keys(newErrors).length === 0) {
  //     setIsSubmitting(true);

  //     const trustedFormData = await getTrustedFormData();

  //     const payload = {
  //       ...mobileFormData,
  //       ...trustedFormData,
  //       gclid: adTrackingRef.current.gclid,
  //       gbraid: adTrackingRef.current.gbraid,
  //       wbraid: adTrackingRef.current.wbraid,
  //     };

  //     try {
  //       const sentToCrm = await saveToCRM({ payload });
  //       sendToRetellCRM({ payload });

  //       Promise.all([
  //         OzempicLawsuitSendAdminEmailE({ formData: payload }),
  //         OzempicLawsuitSendUserEmail({ formData: payload })
  //       ]).catch(err => {
  //         console.error("Email sending failed:", err);
  //       });

  //       if (sentToCrm) {
  //         setShowThankYou(true);

  //         // Track Lead event with advanced matching
  //         const userData = buildAdvancedMatching({
  //           email: payload.email,
  //           phoneNumber: payload.phone
  //         });
  //         trackEventWithUserData('CompleteRegistration', userData);

  //         // Google Ads conversion tracking
  //         if (window.gtag) {
  //           window.gtag('event', 'conversion', {
  //             send_to: 'AW-17927925652/dummy', //change later
  //             value: 1.0,
  //             currency: 'USD'
  //           });
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error submitting form:', error);
  //     } finally {
  //       setIsSubmitting(false);
  //     }
  //   }
  // };

  //Form submission only retell active
  const handleDesktopSubmit = async (e) => {
    e.preventDefault();

    if (currentStep === 1) {
      await handleNext("desktop");
      return;
    }

    setDesktopTouched((current) => ({
      ...current,
      documents: true,
      reviewFilesConsent: true,
      contactPreference: true,
    }));
    const newErrors = validateStepTwo();
    setDesktopErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);

      const trustedFormData = await getTrustedFormData();

      const payload = {
        ...desktopFormData,
        ...trustedFormData,
        documentsCount: documents.length,
        documentNames: documents.map((document) => document.name),
        documentUrls: documents.map((document) => document.url).filter(Boolean),
        contactPreference,
        gclid: adTrackingRef.current.gclid,
        gbraid: adTrackingRef.current.gbraid,
        wbraid: adTrackingRef.current.wbraid,
      };

      try {
        try {
          const currentLeadId = await ensureLeadForForm(desktopFormData);
          if (currentLeadId) {
            await submitFinalLead({ currentLeadId, payload });
          } else {
            console.error("CRM lead creation failed; continuing form submission.");
          }
        } catch (error) {
          console.error("CRM submission failed; continuing form submission.", error);
        }

        Promise.all([
          OzempicLawsuitSendAdminEmailE({ formData: payload }),
          OzempicLawsuitSendUserEmail({ formData: payload }),
        ]).catch((err) => {
          console.error("Email sending failed:", err);
        });

        setShowThankYou(true);

        // Track Lead event with advanced matching
        const userData = buildAdvancedMatching({
          email: payload.email,
          phoneNumber: payload.phone,
        });
        trackEventWithUserData("CompleteRegistration", userData);

        // Google Ads conversion tracking
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-17927925652/dummy", //change it later
            value: 1.0,
            currency: "USD",
          });
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleMobileSubmit = async (e) => {
    e.preventDefault();

    if (currentStep === 1) {
      await handleNext("mobile");
      return;
    }

    setMobileTouched((current) => ({
      ...current,
      documents: true,
      reviewFilesConsent: true,
      contactPreference: true,
    }));
    const newErrors = validateStepTwo();
    setMobileErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);

      const trustedFormData = await getTrustedFormData();

      const payload = {
        ...mobileFormData,
        ...trustedFormData,
        documentsCount: documents.length,
        documentNames: documents.map((document) => document.name),
        documentUrls: documents.map((document) => document.url).filter(Boolean),
        contactPreference,
        gclid: adTrackingRef.current.gclid,
        gbraid: adTrackingRef.current.gbraid,
        wbraid: adTrackingRef.current.wbraid,
      };

      try {
        try {
          const currentLeadId = await ensureLeadForForm(mobileFormData);
          if (currentLeadId) {
            await submitFinalLead({ currentLeadId, payload });
          } else {
            console.error("CRM lead creation failed; continuing form submission.");
          }
        } catch (error) {
          console.error("CRM submission failed; continuing form submission.", error);
        }

        Promise.all([
          OzempicLawsuitSendAdminEmailE({ formData: payload }),
          OzempicLawsuitSendUserEmail({ formData: payload }),
        ]).catch((err) => {
          console.error("Email sending failed:", err);
        });

        // Track Lead event with advanced matching
        const userData = buildAdvancedMatching({
          email: payload.email,
          phoneNumber: payload.phone,
        });
        trackEventWithUserData("CompleteRegistration", userData);

        // Google Ads conversion tracking
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-17927925652/dummy", //change later
            value: 1.0,
            currency: "USD",
          });
        }

        setShowThankYou(true);
        window.setTimeout(() => {
          openPhoneCallScreen(getSelectedCallbackNumber(contactPreference));
        }, 150);
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // ========== USEEFFECTS FOR TRACKING ==========

  useEffect(() => {
    setTexasTimeStatus(getTexasTimeStatus());
    const interval = window.setInterval(() => {
      setTexasTimeStatus(getTexasTimeStatus());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  // Initialize Meta Pixel
  useEffect(() => {
    ensureMetaPixel(META_PIXEL_ID);
    if (window.fbq) window.fbq("track", "PageView");
  }, []);

  useEffect(() => {
    if (showThankYou && window.fbq) {
      window.fbq("track", "ThankYou");
    }
  }, [showThankYou]);

  // Capture ad tracking parameters
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    adTrackingRef.current = {
      gclid: params.get("gclid"),
      gbraid: params.get("gbraid"),
      wbraid: params.get("wbraid"),
    };
  }, []);

  //Microsoft clarity
  useEffect(() => {
    if (window.clarity) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://www.clarity.ms/tag/vmaqjd73tc"; // Depo Provera ID

    document.head.appendChild(script);

    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
  }, []);

  // Initialize Google Tag Manager
  useEffect(() => {
    if (document.getElementById("gtag-depo")) return;

    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-17927925652"; //change later
    gtagScript.id = "gtag-depo";

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17927925652');
    `;

    document.head.appendChild(gtagScript);
    document.head.appendChild(inlineScript);
  }, []);

  if (showThankYou) {
    const selectedCallbackNumber = getSelectedCallbackNumber(contactPreference);
    const contactPreferenceLabel =
      getContactPreferenceLabel(contactPreference);

    return (
      <>
        <div className="hidden md:block">
          <ThankYouPage
            selectedCallbackNumber={selectedCallbackNumber}
            contactPreferenceLabel={contactPreferenceLabel}
          />
        </div>
        <MobileThankYou
          selectedCallbackNumber={selectedCallbackNumber}
          contactPreferenceLabel={contactPreferenceLabel}
        />
      </>
    );
  }

  return (
    <div className="w-full min-h-screen bg-white">
      {/* TrustedForm Hidden Fields */}
      {/* <input type="hidden" id="xxTrustedFormCertUrl" name="xxTrustedFormCertUrl" />
      <input type="hidden" id="xxTrustedFormCertToken" name="xxTrustedFormCertToken" />
      <input type="hidden" id="xxTrustedFormPingUrl" name="xxTrustedFormPingUrl" /> */}

      {/* ================= DESKTOP VIEW ================= */}
      <div className="hidden md:block">
        {/* ===== HEADER ===== */}
        <header className="w-full bg-white border-b border-gray-200">
          <div className="max-w-[1150px] mx-auto px-10 py-3 flex items-center justify-between">
            <img src={logo} alt="Be With Law" className="h-7" />

            <a
              href="tel:18882021350"
              className="
                    flex items-center gap-3
                    bg-[#F8D216]
                    text-[#162766]
                    px-3 py-2
                    rounded-[8px]
                    font-semibold
                    shadow-sm
                    hover:bg-[#E5C414]
                    transition-colors
                    
                "
            >
              <span
                className="
                    flex items-center justify-center
                    w-6 h-6
                    bg-[#162766]
                    rounded-[10px]
                    "
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 16.92V20A2 2 0 0 1 19.82 22
                        A19.86 19.86 0 0 1 2 4.18
                        A2 2 0 0 1 4 2H7.09
                        A2 2 0 0 1 9.09 3.72
                        C9.27 4.88 9.6 6.01 10.07 7.08
                        A2 2 0 0 1 9.62 9.21L8.21 10.62
                        A16 16 0 0 0 13.38 15.79L14.79 14.38
                        A2 2 0 0 1 16.92 13.93
                        C17.99 14.4 19.12 14.73 20.28 14.91
                        A2 2 0 0 1 22 16.92Z"
                    fill="#F8D216"
                  />
                </svg>
              </span>

              <span className="text-[14px] tracking-wide">(866) 376 0014</span>
            </a>
          </div>
        </header>

        {/* ===== HERO SECTION ===== */}
        <section
          className="w-full bg-[#0F2357] overflow-hidden min-h-[62vh]"
          style={{
            backgroundImage:
              currentStep === 2 ? `url(${tyBuildings})` : undefined,
            backgroundRepeat: "no-repeat",
            backgroundPosition: currentStep === 2 ? "bottom" : "bottom center",
            backgroundSize: currentStep === 2 ? "contain" : "100% auto",
          }}
        >
          <div
            className="
              max-w-[1200px]
              mx-auto
              px-10
              grid
              grid-cols-[auto_auto]
              justify-center
              gap-40
              transform
              scale-[0.88]
              xl:scale-[0.91]
              origin-top
            "
          >
            {/* ===== LEFT CONTENT ===== */}
            <div className="pt-0 pb-5 mt-10 text-white flex justify-center">
              <div className="max-w-[520px]">
                {currentStep === 1 ? (
                  <>
                    <h1 className="text-[32px] leading-tight font-bold mb-4">
                      Ozempic Lawsuit:{" "}
                      <span className="text-[#F8D216]">Find If</span>
                      <br />
                      <span className="text-[#F8D216]">You Qualify</span> for Legal
                      <br />
                      Compensation for Ozempic
                      <br />
                      Side Effects Today
                    </h1>

                    <p className="text-[13.5px] text-gray-300 mb-4 leading-relaxed tracking-wide">
                      Have you or a loved one suffered serious side effects after
                      using Ozempic? You???re not alone, and you may be entitled to
                      compensation. Many patients have reported complications like
                      severe eye injuries, such as Non-Arteritic Anterior Ischemic
                      Optic Neuropathy (NAION), after taking Ozempic.
                      <br />
                      <br />
                      <span className="font-bold">At BeWithLaw, we help you:</span>
                      <br />
                      <br />
                      ✅ Understand your legal rights and options if you are harmed
                      by Ozempic. <br />
                      ✅ Get a free, confidential case review to see if you qualify
                      for a lawsuit. <br />
                      ✅ Connect with experienced Ozempic lawsuit attorneys who
                      fight for maximum compensation. <br />
                      ✅ Seek recovery for medical bills, lost wages, and pain and
                      suffering caused by Ozempic side effects. <br /> <br />
                    </p>

                    <div className="w-full flex justify-left">
                      <img
                        src={womanDepo}
                        alt="womanDepo"
                        className="w-full max-w-[340px] rounded-[10px] object-cover"
                      />
                    </div>
                  </>
                ) : (
                  <div className="max-w-[500px] pt-12">
                    <h1 className="text-[34px] leading-tight font-bold mb-5">
                      Thank You - Case Submitted Successfully
                    </h1>

                    <p className="text-[16px] leading-[28px] text-white/90">
                      If you have any medical records or supporting documents related
                      to your condition or medication use, you can upload them below.
                      <br />
                      <br />
                      Providing these documents may help our team review your case
                      faster & determine whether you may qualify for compensation or
                      legal support.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* ===== RIGHT FORM ===== */}
            <div className="pt-10 pb-4 flex justify-center">
              <div className="bg-white text-[#162766] rounded-xl shadow-xl overflow-hidden w-full max-w-[420px]">
                <div className="w-full h-[4px] bg-[#F8D216]" />

                <div className="px-6 py-4">
                  <h2 className="font-poppins text-[16px] font-bold leading-4 text-center mb-4">
                    {currentStep === 1
                      ? "Get Your Free Case Review Today"
                      : "Upload Supporting Documents to Strengthen Your Case"}
                  </h2>

                  <form onSubmit={handleDesktopSubmit} className="space-y-4">
                    <input
                      type="hidden"
                      id="xxTrustedFormCertUrl"
                      name="xxTrustedFormCertUrl"
                    />
                    <input
                      type="hidden"
                      id="xxTrustedFormCertToken"
                      name="xxTrustedFormCertToken"
                    />
                    <input
                      type="hidden"
                      id="xxTrustedFormPingUrl"
                      name="xxTrustedFormPingUrl"
                    />
                    {currentStep === 1 ? (
                      <>
                        <div className="flex flex-col gap-1">
                          <label className="text-[12px] font-medium">
                            Full Name
                          </label>
                          <input
                            type="text"
                            placeholder="John Smith"
                            value={desktopFormData.fullName}
                            onChange={async (e) => {
                              const nextFormData = {
                                ...desktopFormData,
                                fullName: e.target.value,
                              };

                              setDesktopFormData(nextFormData);

                              const currentLeadId =
                                await triggerEarlyLeadIfEligible(nextFormData);

                              if (currentLeadId) {
                                await syncEmailUpdateIfEligible(
                                  nextFormData,
                                  currentLeadId,
                                );
                              }
                            }}
                            className={`w-full border rounded-md px-3 py-2 text-[13px] ${
                              desktopTouched.fullName && desktopErrors.fullName
                                ? "border-red-500 focus:border-red-500"
                                : "border-[#D7DBEA]"
                            }`}
                          />
                          {desktopTouched.fullName &&
                            desktopErrors.fullName && (
                              <span className="text-[11px] text-red-500">
                                {desktopErrors.fullName}
                              </span>
                            )}
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                          <div className="flex flex-col gap-1">
                            <label className="text-[12px] font-medium">
                              Phone Number
                            </label>

                            <div
                              className={`
    flex items-center
    border rounded-md
    px-3 py-2
    transition
    ${
      desktopTouched.phone && desktopErrors.phone
        ? "border-red-500 focus-within:border-red-500"
        : "border-[#D7DBEA] focus-within:border-[#162766]"
    }
  `}
                            >
                              {/* Country Prefix */}
                              <span
                                className="
      flex items-center
      gap-1
      text-[13px]
      font-medium
      text-[#162766]
      pr-2
      border-r
      border-[#E5E7EB]
      mr-2
    "
                              >
                                +1
                              </span>

                              {/* Phone Input */}
                              <input
                                type="text"
                                placeholder="(555) 123-4567"
                                value={desktopFormData.phone.replace("+1 ", "")}
                                inputMode="numeric"
                                autoComplete="tel"
                                onChange={async (e) => {
                                  const rawDigits = e.target.value.replace(
                                    /\D/g,
                                    "",
                                  );

                                  const formatted = formatPhoneInput(rawDigits);

                                  const nextFormData = {
                                    ...desktopFormData,
                                    phone: formatted,
                                  };

                                  setDesktopFormData(nextFormData);

                                  const currentLeadId =
                                    await triggerEarlyLeadIfEligible(
                                      nextFormData,
                                    );

                                  if (currentLeadId) {
                                    await syncEmailUpdateIfEligible(
                                      nextFormData,
                                      currentLeadId,
                                    );
                                  }
                                }}
                                maxLength={14}
                                className="
        w-full
        outline-none
        text-[13px]
        placeholder:text-gray-400
        bg-transparent
      "
                              />
                            </div>

                            {desktopTouched.phone && desktopErrors.phone && (
                              <span className="text-[11px] text-red-500">
                                {desktopErrors.phone}
                              </span>
                            )}
                          </div>

                          <div className="flex flex-col gap-1">
                            <label className="text-[12px] font-medium">
                              Email
                            </label>
                            <input
                              type="email"
                              placeholder="e.g. john.smith@mail.com"
                              value={desktopFormData.email}
                              onChange={async (e) => {
                                const nextFormData = {
                                  ...desktopFormData,
                                  email: e.target.value,
                                };

                                setDesktopFormData(nextFormData);

                                await syncEmailUpdateIfEligible(nextFormData);
                              }}
                              className={`w-full border rounded-md px-3 py-2 text-[13px] ${
                                desktopTouched.email && desktopErrors.email
                                  ? "border-red-500 focus:border-red-500"
                                  : "border-[#D7DBEA]"
                              }`}
                            />
                            {desktopTouched.email && desktopErrors.email && (
                              <span className="text-[11px] text-red-500">
                                {desktopErrors.email}
                              </span>
                            )}
                          </div>
                        </div>

                        {[
                          {
                            q: "Q1. Have you been diagnosed with NAION (Non-Arteritic Anterior Ischemic Optic Neuropathy)?",
                            name: "q1",
                          },
                          {
                            q: "Q2. Have you taken GLP-1 medications such as Ozempic, Wegovy, Rybelsus, Trulicity, Mounjaro, or Zepbound?",
                            name: "q2",
                          },
                          {
                            q: "Q3. Are you currently working with an attorney regarding this matter?",
                            name: "q3",
                          },
                        ].map(({ q, name }) => (
                          <div key={name} className="space-y-1">
                            <p className=" text-[13px] font-medium">{q}</p>
                            <div className="grid grid-cols-2 gap-3">
                              {["Yes", "No"].map((opt) => (
                                <label
                                  key={opt}
                                  className="flex items-center gap-2 px-3 py-2.5 rounded-md border border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                                >
                                  <input
                                    type="radio"
                                    name={name}
                                    value={opt}
                                    checked={desktopFormData[name] === opt}
                                    onChange={async (e) => {
                                      const nextFormData = {
                                        ...desktopFormData,
                                        [name]: e.target.value,
                                      };

                                      setDesktopFormData(nextFormData);

                                      const currentLeadId =
                                        await triggerEarlyLeadIfEligible(
                                          nextFormData,
                                        );

                                      if (currentLeadId) {
                                        await syncPartialLead({
                                          nextFormData,
                                          currentLeadId,
                                        });
                                      }
                                    }}
                                    className="peer hidden"
                                  />

                                  <span
                                    className="
                                  w-4 h-4
                                  rounded-full
                                  border border-[#162766]
                                  flex items-center justify-center
                                  peer-checked:border-[#162766]
                                  peer-checked:bg-[#162766]
                                  [&>svg]:hidden
                                  peer-checked:[&>svg]:block
                                "
                                  >
                                    <svg
                                      width="8"
                                      height="6"
                                      viewBox="0 0 9 7"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                                        fill="#F8D216"
                                        stroke="#F8D216"
                                        strokeWidth="0.5"
                                      />
                                    </svg>
                                  </span>
                                  <span className="text-[13px] font-medium">
                                    {opt}
                                  </span>
                                </label>
                              ))}
                            </div>
                            {desktopTouched[name] && desktopErrors[name] && (
                              <span className="text-[11px] text-red-500">
                                {desktopErrors[name]}
                              </span>
                            )}
                          </div>
                        ))}

                        <div>
                          <label className="flex items-start gap-2 text-[10.5px] leading-snug text-[#5A627A]">
                            <input
                              type="checkbox"
                              checked={desktopFormData.consent}
                              onChange={async (e) => {
                                const nextFormData = {
                                  ...desktopFormData,
                                  consent: e.target.checked,
                                };

                                setDesktopFormData(nextFormData);

                                const currentLeadId =
                                  await triggerEarlyLeadIfEligible(
                                    nextFormData,
                                  );

                                if (currentLeadId) {
                                  await syncPartialLead({
                                    nextFormData,
                                    currentLeadId,
                                  });
                                }
                              }}
                              className="mt-[2px] accent-[#162766]"
                            />
                            <span>
                              I agree to the{" "}
                              <a
                                href="/PrivacyPolicy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-blue-800 font-bold"
                              >
                                Privacy Policy
                              </a>{" "}
                              and{" "}
                              <a
                                href="/Disclaimer"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-blue-800 font-bold"
                              >
                                Disclaimer
                              </a>{" "}
                              and give my express written and give my express
                              written consent, affiliates and/or lawyer to
                              contact you at the number provided above, even if
                              this number is a wireless number or if I am
                              presently listed on a Do Not Call list. I
                              understand that I may be contacted by telephone,
                              email, text message, ai call from ai agents or
                              mail regarding case options and that I may be
                              called using automatic dialing equipment. Message
                              and data rates may apply. My consent does not
                              require purchase. This is Legal advertising.
                            </span>
                          </label>
                          {desktopTouched.consent && desktopErrors.consent && (
                            <span className="text-[11px] text-red-500 block mt-1">
                              {desktopErrors.consent}
                            </span>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <UploadZone
                          documents={documents}
                          uploadProgress={uploadProgress}
                          uploadError={uploadError}
                          onFileUpload={handleFileUpload}
                          onRemoveDocument={handleRemoveDocument}
                          fileInputRef={fileInputRef}
                        />
                        {desktopTouched.documents &&
                          desktopErrors.documents && (
                            <span className="block text-[11px] text-red-500">
                              {desktopErrors.documents}
                            </span>
                          )}
                        <label className="flex items-start gap-2 text-[10.5px] leading-snug text-[#5A627A]">
                          <input
                            type="checkbox"
                            checked={reviewFilesConsent}
                            onChange={async (e) => {
                              const nextReviewFilesConsent = e.target.checked;

                              setReviewFilesConsent(nextReviewFilesConsent);
                              setDesktopErrors((current) => ({
                                ...current,
                                reviewFilesConsent: "",
                              }));

                              await syncPartialLead({
                                nextFormData: desktopFormData,
                                nextReviewFilesConsent,
                              });
                            }}
                            className="mt-[2px] accent-[#162766]"
                          />
                          <span>
                           I provide my express written consent to upload and share my medical records and related health information or the purpose of evaluating my case. I understand this information may be reviewed and shared with affiliated legal partners or licensed attorneys. I acknowledge this does not guarantee representation or compensation.
                          </span>
                        </label>
                        {desktopTouched.reviewFilesConsent &&
                          desktopErrors.reviewFilesConsent && (
                            <span className="text-[11px] text-red-500 block mt-1">
                              {desktopErrors.reviewFilesConsent}
                            </span>
                          )}

                        <button
                          type="submit"
                          disabled={isSubmitting || !reviewFilesConsent}
                          className={`w-full bg-[#F8D216] text-[#162766] tracking-[0.15em] font-bold py-2.5 rounded-lg hover:bg-[#E5C414] transition-colors flex items-center justify-center gap-2 ${
                            isSubmitting || !reviewFilesConsent
                              ? "opacity-70 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          {isSubmitting ? (
                            <>
                              <div className="w-5 h-5 border-2 border-[#162766] border-t-transparent rounded-full animate-spin"></div>
                              <span>SENDING FILES...</span>
                            </>
                          ) : (
                            "SEND FILES FOR REVIEW"
                          )}
                        </button>

                        <div className="space-y-3">
                          <div className="grid gap-3">
                            {/* Human — First */}
                            <ContactOption
                              value="human"
                              selectedValue={contactPreference}
                              onSelect={async (value) => {
                                setContactPreference(value);
                                setDesktopErrors((current) => ({
                                  ...current,
                                  contactPreference: "",
                                }));

                                await syncPartialLead({
                                  nextFormData: desktopFormData,
                                  nextContactPreference: value,
                                });
                              }}
                              title="Call Us Now (Human Agent)"
                              description={`Available Mon – Fri ${HUMAN_AGENT_HOURS}`}
                              disabled={!texasTimeStatus.isOpen}
                            />

                            {/* AI — Second */}
                            <ContactOption
                              value="ai"
                              selectedValue={contactPreference}
                              onSelect={async (value) => {
                                setContactPreference(value);
                                setDesktopErrors((current) => ({
                                  ...current,
                                  contactPreference: "",
                                }));

                                await syncPartialLead({
                                  nextFormData: desktopFormData,
                                  nextContactPreference: value,
                                });
                              }}
                              title="Call Us Now – 24/7 (Ai Agent)"
                              description="AI assistant Available anytime, day or night"
                            />
                          </div>

                          {desktopTouched.contactPreference &&
                            desktopErrors.contactPreference && (
                              <span className="text-[11px] text-red-500">
                                {desktopErrors.contactPreference}
                              </span>
                            )}
                        </div>
                      </>
                    )}

                    {currentStep === 1 && (
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full bg-[#F8D216] text-[#162766] tracking-[0.15em] font-bold py-2.5 rounded-lg hover:bg-[#E5C414] transition-colors flex items-center justify-center gap-2 ${
                          isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                      >
                        {isSubmitting ? (
                          <>
                            <div className="w-5 h-5 border-2 border-[#162766] border-t-transparent rounded-full animate-spin"></div>
                            <span>SUBMITTING...</span>
                          </>
                        ) : (
                          "REVIEW MY CASE"
                        )}
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== UNDERSTANDING SECTION ===== */}
        <section className="w-full bg-[#FAF8E9] py-10">
          <div className="max-w-[1100px] mx-auto px-10 grid grid-cols-2 gap-10 items-center">
            {/* LEFT CONTENT */}
            <div>
              <h2 className="text-[24px] leading-[28px] font-semibold text-[#162766] mb-4">
                About Ozempic and the Ozempic Lawsuit
              </h2>

              <p className="text-[12px] leading-[16px] text-[#4B5563] mb-6 max-w-[520px]">
                Ozempic is a brand-name GLP-1 medication containing semaglutide,
                commonly prescribed for type 2 diabetes and sometimes for weight
                loss. Lawsuits now allege possible links between Ozempic and
                serious side effects, especially severe eye injuries such as
                Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION), which
                can cause sudden and permanent vision loss.
              </p>

              <p className="text-[12px] leading-[16px] text-[#4B5563] mb-6 max-w-[520px]">
                An Ozempic lawsuit claims patients were not adequately warned
                about these risks. BeWithLaw helps affected individuals check
                eligibility and connect with qualified attorneys to pursue
                compensation for medical costs and long-term complications.
              </p>
            </div>

            {/* RIGHT IMAGE */}
            <div className="w-full flex justify-end">
              <img
                src={newlanderimg2}
                alt="Ozempic Injection"
                className="w-full max-w-[420px] rounded-[5px] object-cover"
              />
            </div>
          </div>
        </section>

        {/* ===== QUALIFY SECTION ===== */}
        <section className="w-full bg-white py-12">
          <div className="max-w-[1040px] mx-auto px-10 grid grid-cols-2 gap-14 items-center">
            {/* LEFT IMAGE */}
            <div className="w-full flex justify-end">
              <img
                src={womanCry}
                alt="Woman Stomach"
                className="w-full max-w-[540px] rounded-[5px] object-cover"
              />
            </div>

            {/* RIGHT CONTENT */}
            <div>
              <h2 className="text-[20px] leading-[26px] font-semibold text-[#162766] mb-4">
                Ozempic Lawsuit Eligibility for Vision and Intestinal Injury
                Claims
              </h2>

              <p className="text-[12px] leading-[16px] text-[#4B5563] mb-4 max-w-[520px]">
                To qualify for compensation through an Ozempic lawsuit, all the
                following requirements must be met:
              </p>

              <ul className="space-y-3 text-[12px] leading-[16px] text-[#4B5563] max-w-[520px] mb-6">
                <li className="flex gap-3">
                  ●
                  <span>
                    Must have been diagnosed with Non-Arteritic Anterior
                    Ischemic Optic Neuropathy (NAION) caused by Ozempic or
                    another GLP-1 drug.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    The injury must have occurred while actively taking the
                    medication.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    You must have stopped the drug at the time of diagnosis.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    You must have lasting harm, such as permanent vision
                    impairment.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    You must have been 75 years old or younger at the time of
                    use.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    You must have used a brand-name GLP-1 medication only:
                    Ozempic, Wegovy, Rybelsus, Trulicity, Mounjaro, or Zepbound.
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    You must have a valid U.S. Social Security number
                    (confirmation only).
                  </span>
                </li>

                <li className="flex gap-3">
                  ●
                  <span>
                    Your claim must fall within the applicable statute of
                    limitations based on your state and diagnosis date.
                  </span>
                </li>
              </ul>

              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                    bg-[#F8D216]
                    text-[#162766]
                    text-[12px]
                    font-bold
                    tracking-[0.15em]
                    px-8 py-3
                    rounded-[8px]
                    hover:bg-[#E5C414]
                    transition-colors
                    "
              >
                SEE IF YOU QUALIFY
              </button>
            </div>
          </div>
        </section>

        {/* ===== WAVE SECTION ===== */}
        <section className="relative w-full bg-white overflow-hidden mb-5">
          {/* Waves background */}
          <img
            src={wavesImage}
            alt="Decorative waves"
            className="w-full h-auto"
          />

          {/* Content overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="max-w-[720px] px-6 text-center">
              <h2 className="text-[28px] leading-[36px] font-bold text-[#162766] mb-3">
                Check Your Eligibility Today
              </h2>

              <p className="text-[14px] leading-[20px] text-[#162766] font-semibold mb-6 max-w-[620px] mx-auto">
                Don’t wait! Your legal rights may be limited by time. Fill out
                our quick, confidential form to see if you qualify for an
                Ozempic lawsuit. Our experienced attorneys will review your case
                for free and guide you through the process.
              </p>

              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                    bg-[#162766]
                    text-white
                    text-[12px]
                    font-bold
                    tracking-[0.12em]
                    px-8 py-3
                    rounded-[8px]
                    hover:bg-[#0F1E4D]
                    transition-colors
                    "
              >
                FREE ELIGIBILITY CHECK
              </button>
            </div>
          </div>
        </section>

        {/* ===== CARDS SECTION ===== */}
        <section className="w-full bg-white py-16">
          <div className="max-w-[1040px] mx-auto px-10">
            <div className="grid grid-cols-3 gap-8 justify-items-center">
              {/* Card 1 */}
              <div className="w-full max-w-[280px] bg-[#E8E9F0] rounded-[16px] px-6 py-8 text-center">
                <img
                  src={caseNoteIcon}
                  alt="Case Review"
                  className="w-[56px] h-[56px] mx-auto mb-4"
                />
                <h3 className="text-[15px] font-semibold text-[#162766] mb-2">
                  Case Review
                </h3>
                <p className="text-[13px] leading-[20px] text-[#5A627A]">
                  Share your details, and we will check whether you qualify.
                </p>
              </div>

              {/* Card 2 */}
              <div className="w-full max-w-[280px] bg-[#E8E9F0] rounded-[16px] px-6 py-8 text-center">
                <img
                  src={attorneyCallIcon}
                  alt="Attorney Connection"
                  className="w-[56px] h-[56px] mx-auto mb-4"
                />
                <h3 className="text-[15px] font-semibold text-[#162766] mb-2">
                  Attorney Connection
                </h3>
                <p className="text-[13px] leading-[20px] text-[#5A627A]">
                  Get matched with experienced Ozempic lawyers.
                </p>
              </div>

              {/* Card 3 */}
              <div className="w-full max-w-[280px] bg-[#E8E9F0] rounded-[16px] px-6 py-8 text-center">
                <img
                  src={compensationIcon}
                  alt="Compensation Pursuit"
                  className="w-[56px] h-[56px] mx-auto mb-4"
                />
                <h3 className="text-[15px] font-semibold text-[#162766] mb-2">
                  Compensation Pursuit
                </h3>
                <p className="text-[13px] leading-[20px] text-[#5A627A]">
                  Your attorney files your case and fights for maximum recovery.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ===== FOOTER ===== */}
        <section className="w-full bg-[#162B6F] py-10">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col items-center text-center">
            <h2 className="text-[32px] leading-[40px] font-semibold text-white">
              Ready To Get a Free Ozempic Lawsuit Case Review?
            </h2>

            <div className="w-[44px] h-[3px] bg-[#F4C430] mt-4 mb-6" />

            <p className="text-[28px] leading-[28px] text-white/90 mb-8">
              Contact our legal partners today.
            </p>

            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="bg-[#F9D51C] text-[#0E1E4D] text-[14px] font-bold tracking-widest h-[44px] w-[240px] rounded-[6px]"
            >
              GET HELP NOW
            </button>
          </div>
        </section>
      </div>

      {/* ================= MOBILE VIEW ================= */}
      <div className="md:hidden w-full bg-[#0F2357]">
        <div className="flex items-center justify-between px-4 py-3 bg-white">
          <img src={logo} alt="Be With Law" className="h-7" />

          <div className="relative">
            <img
              src={callIcon}
              alt="Call"
              className="w-9 h-9 cursor-pointer"
              onClick={() => setShowCallPopup((prev) => !prev)}
            />

            {showCallPopup && (
              <div
                className="
                  absolute
                  right-0
                  top-12
                  bg-[#162766]
                  text-white
                  text-[13px]
                  px-4
                  py-2
                  rounded-lg
                  shadow-lg
                  whitespace-nowrap
                  z-50
                "
              >
                (866) 376 0014
              </div>
            )}
          </div>
        </div>

        <div
        className="px-4 pt-10 pb-14 text-white"
        style={{
          
        }}
      >
        {currentStep === 1 ? (
          <>
            <h1 className="text-[22px] leading-[28px] font-semibold mb-4">
              Ozempic Lawsuit: <span className="text-[#F8D216]">Find If You</span>
              <br />
              <span className="text-[#F8D216]">Qualify</span> for Legal Compensation
              <br />
              for Ozempic Side Effects Today
            </h1>

            <p className="text-[14px] leading-[22px] mb-6">
              Have you or a loved one suffered serious side effects after using
              Ozempic? You???re not alone, and you may be entitled to compensation.
              Many patients have reported complications like severe eye injuries,
              such as Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION),
              after taking Ozempic.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-[24px] leading-[30px] font-semibold mb-4">
              Thank You - Case Submitted Successfully
            </h1>

            <p className="text-[14px] leading-[22px] text-white/90">
              If you have any medical records or supporting documents related to your condition or medication use, you can upload them below.
              <br />
              <br />
              Providing these documents may help our team review your case faster & determine whether you may qualify for compensation or legal support.
            </p>
          </>
        )}
      </div>

      {/* ===== MOBILE FORM ===== */}
      <div className="md:hidden bg-white px-4 -mt-6 pb-10">
        <div className="bg-white rounded-[16px] shadow-xl overflow-hidden px-4 py-6">
          <h2 className="font-poppins text-[18px] font-bold text-[#162766] mb-4">
            {currentStep === 1
              ? "Get Your Free Case Review Today"
              : "Upload Docs & Choose Your Call"}
          </h2>

          <form onSubmit={handleMobileSubmit} className="space-y-4">
            <input
              type="hidden"
              id="xxTrustedFormCertUrl_mobile"
              name="xxTrustedFormCertUrl"
            />
            <input
              type="hidden"
              id="xxTrustedFormCertToken_mobile"
              name="xxTrustedFormCertToken"
            />
            <input
              type="hidden"
              id="xxTrustedFormPingUrl_mobile"
              name="xxTrustedFormPingUrl"
            />
            {currentStep === 1 ? (
              <>
                <div>
                  <label className="text-[13px] font-medium text-[#162766]">
                    Full name
                  </label>
                  <input
                    value={mobileFormData.fullName}
                    onChange={async (e) => {
                      const nextFormData = {
                        ...mobileFormData,
                        fullName: e.target.value,
                      };

                      setMobileFormData(nextFormData);

                      const currentLeadId =
                        await triggerEarlyLeadIfEligible(nextFormData);

                      if (currentLeadId) {
                        await syncEmailUpdateIfEligible(
                          nextFormData,
                          currentLeadId,
                        );
                      }
                    }}
                    className={`mt-1 w-full border rounded-md px-3 py-2 text-[14px] ${
                      mobileTouched.fullName && mobileErrors.fullName
                        ? "border-red-500 focus:border-red-500"
                        : "border-[#D7DBEA]"
                    }`}
                    placeholder="John Smith"
                  />
                  {mobileTouched.fullName && mobileErrors.fullName && (
                    <span className="text-[11px] text-red-500">
                      {mobileErrors.fullName}
                    </span>
                  )}
                </div>

                <div>
                  <label className="text-[13px] font-medium text-[#162766]">
                    Phone Number
                  </label>
                  <div className="mt-1 flex items-center border rounded-md px-3 py-2 border-[#D7DBEA] focus-within:border-[#162766] focus-within:ring-2 focus-within:ring-[#162766]/20">
                    {/* +1 Prefix */}
                    <span
                      className="
    flex items-center
    text-[14px]
    font-semibold
    text-[#162766]
    pr-2
    border-r
    border-[#E5E7EB]
    mr-2
  "
                    >
                      +1
                    </span>

                    {/* Phone Input */}
                    <input
                      type="text"
                      placeholder="(555) 123-4567"
                      value={mobileFormData.phone.replace("+1 ", "")}
                      inputMode=" numeric"
                      autoComplete="tel"
                      onChange={async (e) => {
                        const rawDigits = e.target.value.replace(/\D/g, "");

                        const formatted = formatPhoneInput(rawDigits);

                        const nextFormData = {
                          ...mobileFormData,
                          phone: formatted,
                        };

                        setMobileFormData(nextFormData);

                        const currentLeadId =
                          await triggerEarlyLeadIfEligible(nextFormData);

                        if (currentLeadId) {
                          await syncEmailUpdateIfEligible(
                            nextFormData,
                            currentLeadId,
                          );
                        }
                      }}
                      maxLength={14}
                      className="
    w-full
    outline-none
    text-[14px]
    placeholder:text-gray-400/80
    bg-transparent
    "
                    />
                  </div>
                  {mobileTouched.phone && mobileErrors.phone && (
                    <span className="text-[11px] text-red-500">
                      {mobileErrors.phone}
                    </span>
                  )}
                </div>

                <div>
                  <label className="text-[13px] font-medium text-[#162766]">
                    Email
                  </label>
                  <input
                    type="email"
                    value={mobileFormData.email}
                    onChange={async (e) => {
                      const nextFormData = {
                        ...mobileFormData,
                        email: e.target.value,
                      };

                      setMobileFormData(nextFormData);

                      await syncEmailUpdateIfEligible(nextFormData);
                    }}
                    className={`mt-1 w-full border rounded-md px-3 py-2 text-[14px] ${
                      mobileTouched.email && mobileErrors.email
                        ? "border-red-500 focus:border-red-500"
                        : "border-[#D7DBEA]"
                    }`}
                    placeholder="e.g. john.smith@mail.com"
                  />
                  {mobileTouched.email && mobileErrors.email && (
                    <span className="text-[11px] text-red-500">
                      {mobileErrors.email}
                    </span>
                  )}
                </div>

                {[
                  "Have you been diagnosed with NAION (Non-Arteritic Anterior Ischemic Optic Neuropathy)?",
                  "Have you taken GLP-1 medications such as Ozempic, Wegovy, Rybelsus, Trulicity, Mounjaro, or Zepbound?",
                  "Are you currently working with an attorney regarding this matter?",
                ].map((q, i) => (
                  <div key={i}>
                    <p className=" text-[13px] font-medium text-[#162766] mb-2">
                      Q{i + 1}. {q}
                    </p>
                    <div className="flex gap-3">
                      {["Yes", "No"].map((opt) => (
                        <label
                          key={opt}
                          className="flex-1 flex items-center gap-2 px-3 py-2 border rounded-md border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                        >
                          <input
                            type="radio"
                            name={`mq${i}`}
                            value={opt}
                            checked={mobileFormData[`q${i + 1}`] === opt}
                            onChange={async (e) => {
                              const nextFormData = {
                                ...mobileFormData,
                                [`q${i + 1}`]: e.target.value,
                              };

                              setMobileFormData(nextFormData);

                              const currentLeadId =
                                await triggerEarlyLeadIfEligible(nextFormData);

                              if (currentLeadId) {
                                await syncPartialLead({
                                  nextFormData,
                                  currentLeadId,
                                });
                              }
                            }}
                            className="peer hidden"
                          />

                          <span
                            className="
                          w-4 h-4
                          rounded-full
                          border border-[#162766]
                          flex items-center justify-center
                          peer-checked:border-[#162766]
                          peer-checked:bg-[#162766]
                          [&>svg]:hidden
                          peer-checked:[&>svg]:block
                        "
                          >
                            <svg
                              width="10"
                              height="8"
                              viewBox="0 0 9 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                                fill="#F8D216"
                                stroke="#F8D216"
                                strokeWidth="0.5"
                              />
                            </svg>
                          </span>

                          <span className="text-[13px]">{opt}</span>
                        </label>
                      ))}
                    </div>
                    {mobileTouched[`q${i + 1}`] &&
                      mobileErrors[`q${i + 1}`] && (
                        <span className="text-[11px] text-red-500">
                          {mobileErrors[`q${i + 1}`]}
                        </span>
                      )}
                  </div>
                ))}

                <div>
                  <label className="flex items-start gap-2 text-[11px] text-[#5A627A] leading-snug">
                    <input
                      type="checkbox"
                      checked={mobileFormData.consent}
                      onChange={async (e) => {
                        const nextFormData = {
                          ...mobileFormData,
                          consent: e.target.checked,
                        };

                        setMobileFormData(nextFormData);

                        const currentLeadId =
                          await triggerEarlyLeadIfEligible(nextFormData);

                        if (currentLeadId) {
                          await syncPartialLead({
                            nextFormData,
                            currentLeadId,
                          });
                        }
                      }}
                      className="mt-0.5 accent-[#162766]"
                    />
                    <span>
                      I agree to the{" "}
                      <a
                        href="/PrivacyPolicy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-800 font-bold"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a
                        href="/Disclaimer"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-800 font-bold"
                      >
                        Disclaimer
                      </a>{" "}
                      and give my express written consent, affiliates and/or
                      lawyer to contact you at the number provided above, even
                      if this number is a wireless number or if I am presently
                      listed on a Do Not Call list. I understand that I may be
                      contacted by telephone, email, text message, ai call from
                      ai agents or mail regarding case options and that I may be
                      called using automatic dialing equipment. Message and data
                      rates may apply. My consent does not require purchase.
                      This is Legal advertising rates may apply. My consent does
                      not require purchase. This is Legal advertising
                    </span>
                  </label>
                  {mobileTouched.consent && mobileErrors.consent && (
                    <span className="text-[11px] text-red-500 block mt-1">
                      {mobileErrors.consent}
                    </span>
                  )}
                </div>
              </>
            ) : (
              <>
                <UploadZone
                  documents={documents}
                  uploadProgress={uploadProgress}
                  uploadError={uploadError}
                  onFileUpload={handleFileUpload}
                  onRemoveDocument={handleRemoveDocument}
                  fileInputRef={fileInputRef}
                />
                {mobileTouched.documents && mobileErrors.documents && (
                  <span className="block text-[11px] text-red-500">
                    {mobileErrors.documents}
                  </span>
                )}

                <label className="flex items-start gap-2 text-[11px] text-[#5A627A] leading-snug">
                  <input
                    type="checkbox"
                    checked={reviewFilesConsent}
                    onChange={async (e) => {
                      const nextReviewFilesConsent = e.target.checked;

                      setReviewFilesConsent(nextReviewFilesConsent);
                      setMobileErrors((current) => ({
                        ...current,
                        reviewFilesConsent: "",
                      }));

                      await syncPartialLead({
                        nextFormData: mobileFormData,
                        nextReviewFilesConsent,
                      });
                    }}
                    className="mt-0.5 accent-[#162766]"
                  />
                  <span>
I provide my express written consent to upload and share my medical records and related health information or the purpose of evaluating my case. I understand this information may be reviewed and shared with affiliated legal partners or licensed attorneys. I acknowledge this does not guarantee representation or compensation.
                  </span>
                </label>
                {mobileTouched.reviewFilesConsent &&
                  mobileErrors.reviewFilesConsent && (
                    <span className="block text-[11px] text-red-500">
                      {mobileErrors.reviewFilesConsent}
                    </span>
                  )}

              </>
            )}

            <button
              type="submit"
              disabled={isSubmitting || (currentStep === 2 && !reviewFilesConsent)}
              className={`w-full bg-[#F8D216] text-[#162766] font-bold tracking-widest py-3 rounded-lg hover:bg-[#E5C414] transition-colors flex items-center justify-center gap-2 ${
                isSubmitting || (currentStep === 2 && !reviewFilesConsent)
                  ? "opacity-70 cursor-not-allowed"
                  : ""
              }`}
            >
              {isSubmitting ? (
                <>
                  <div className="w-5 h-5 border-2 border-[#162766] border-t-transparent rounded-full animate-spin"></div>
                  <span>SUBMITTING...</span>
                </>
              ) : currentStep === 1 ? (
                "REVIEW MY CASE"
              ) : (
                "SEND FILES FOR REVIEW"
              )}
            </button>

            {currentStep === 2 && (
              <div className="space-y-3">
                {/* <div>
                  <p className=" text-[13px] font-medium text-[#162766]">
                    Choose your call option
                  </p>
                  <p className="mt-1 text-[15px] leading-[20px] text-[#5A627A]">
                    AI is available 24/7. Human agents answer during{" "}
                    {HUMAN_AGENT_HOURS}.
                    <br />
                    Current Central Time (CT):{" "}
                    <span className="font-semibold text-[#162766] tabular-nums">
                      {texasTimeStatus.currentTimeLabel}
                    </span>
                  </p>
                </div> */}

                <div className="grid gap-3">
                  <ContactOption
                    value="ai"
                    selectedValue={contactPreference}
                    onSelect={async (value) => {
                      setContactPreference(value);
                      setMobileErrors((current) => ({
                        ...current,
                        contactPreference: "",
                      }));
                      await syncPartialLead({
                        nextFormData: mobileFormData,
                        nextContactPreference: value,
                      });
                    }}
                    title="24/7 AI Agent Call"
                    description="Choose this for an immediate AI-powered follow-up to continue your case review anytime."
                    meta="Available any time"
                    status={{ label: "Open 24/7", variant: "open" }}
                  />
                  <ContactOption
                    value="human"
                    selectedValue={contactPreference}
                    onSelect={async (value) => {
                      setContactPreference(value);
                      setMobileErrors((current) => ({
                        ...current,
                        contactPreference: "",
                      }));
                      await syncPartialLead({
                        nextFormData: mobileFormData,
                        nextContactPreference: value,
                      });
                    }}
                    title="Human Agent Call"
                    description={
                      texasTimeStatus.isOpen
                        ? "Choose this if you want a human agent to contact you during business hours only."
                        : "Human agents are currently unavailable. Please use the AI option now or come back during business hours."
                    }
                    meta={`Available ${HUMAN_AGENT_HOURS}`}
                    disabled={!texasTimeStatus.isOpen}
                    status={
                      texasTimeStatus.isOpen
                        ? { label: "Open Now", variant: "open" }
                        : { label: "After Hours", variant: "closed" }
                    }
                  />
                </div>
                {mobileTouched.contactPreference &&
                  mobileErrors.contactPreference && (
                    <span className="text-[11px] text-red-500">
                      {mobileErrors.contactPreference}
                    </span>
                  )}
              </div>
            )}
          </form>
        </div>
      </div>

      {/* ================= MOBILE UNDERSTANDING DEPO ================= */}
      <section className="md:hidden w-full bg-[#FAF8E9] px-4 py-10">
        <div className="max-w-[360px] mx-auto">
          {/* Image */}
          <div className="mb-6">
            <img
              src={newlanderimg2}
              alt="Ozempic Injection"
              className="w-full rounded-[16px] object-cover"
            />
          </div>

          {/* Heading */}
          <h2 className="text-[20px] leading-[28px] font-bold text-[#162766] mb-4">
            About Ozempic and the Ozempic Lawsuit
          </h2>

          {/* Paragraphs */}
          <p className="text-[13px] leading-[22px] text-[#4B5563] mb-4">
            Ozempic is a brand-name GLP-1 medication containing semaglutide,
            commonly prescribed for type 2 diabetes and sometimes for weight
            loss. Lawsuits now allege possible links between Ozempic and serious
            side effects, especially severe eye injuries such as Non-Arteritic
            Anterior Ischemic Optic Neuropathy (NAION), which can cause sudden
            and permanent vision loss.
          </p>

          <p className="text-[13px] leading-[22px] text-[#4B5563] mb-4">
            An Ozempic lawsuit claims patients were not adequately warned about
            these risks. BeWithLaw helps affected individuals check eligibility
            and connect with qualified attorneys to pursue compensation for
            medical costs and long-term complications.
          </p>
        </div>
      </section>

      {/* ================= MOBILE ELIGIBILITY ================= */}
      <section className="md:hidden w-full bg-white px-4 py-10">
        <div className="max-w-[360px] mx-auto">
          {/* Image */}
          <div className="mb-6">
            <img
              src={womanCry}
              alt="Woman crying"
              className="w-full rounded-[16px] object-cover"
            />
          </div>

          {/* Heading */}
          <h2 className="text-[20px] leading-[28px] font-semibold text-[#162766] mb-3">
            Ozempic Lawsuit Eligibility for Vision and Intestinal Injury Claims
          </h2>

          {/* Intro text */}
          <p className="text-[13px] leading-[22px] text-[#4B5563] mb-4">
            To qualify for compensation through an Ozempic lawsuit, all the
            following requirements must be met:
          </p>

          {/* Eligibility list */}
          <div className="space-y-3 text-[13px] leading-[22px] text-[#4B5563] mb-6">
            <p>
              ● Must have been diagnosed with Non-Arteritic Anterior Ischemic
              Optic Neuropathy (NAION) caused by Ozempic or another GLP-1 drug.
            </p>

            <p>
              ● The injury must have occurred while actively taking the
              medication.
            </p>

            <p>● You must have stopped the drug at the time of diagnosis.</p>

            <p>
              ● You must have lasting harm, such as permanent vision impairment.
            </p>

            <p>
              ● You must have been 75 years old or younger at the time of use.
            </p>

            <p>
              ● You must have used a brand-name GLP-1 medication only: Ozempic,
              Wegovy, Rybelsus, Trulicity, Mounjaro, or Zepbound.
            </p>

            <p>
              ● You must have a valid U.S. Social Security number (confirmation
              only).
            </p>

            <p>
              ● Your claim must fall within the applicable statute of
              limitations based on your state and diagnosis date.
            </p>
          </div>

          {/* CTA */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="
              w-full
              bg-[#F8D216]
              text-[#162766]
              text-[12px]
              font-bold
              tracking-[0.15em]
              py-3
              rounded-[8px]
              hover:bg-[#E5C414]
              transition-colors
            "
          >
            SEE IF YOU QUALIFY
          </button>
        </div>
      </section>

      {/* ================= MOBILE ELIGIBILITY CTA ================= */}
      <section className="md:hidden relative w-full bg-white overflow-hidden">
        {/* Waves background */}
        <img src={wavesMobile} alt="" className="w-full block" />

        {/* Content overlay */}
        <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
          <h2 className="text-[22px] leading-[28px] font-bold text-[#162766] mb-3">
            Check Your Eligibility Today
          </h2>

          <p className="text-[14px] leading-[22px] font-medium text-[#162766] max-w-[320px] mb-5">
            Don’t wait! Your legal rights may be limited by time. Fill out our
            quick, confidential form to see if you qualify for an Ozempic
            lawsuit. Our experienced attorneys will review your case for free
            and guide you through the process.
          </p>

          <button
            className="
              bg-[#162766]
              text-white
              text-[13px]
              font-bold
              tracking-widest
              px-8
              py-3
              rounded-[8px]
              w-full
            "
          >
            FREE ELIGIBILITY CHECK
          </button>
        </div>
      </section>

      {/* ================= MOBILE STEPS ================= */}
      <section className="md:hidden w-full bg-white px-5 py-10">
        <div className="flex flex-col gap-6">
          {/* Card 1 */}
          <div className="bg-[#E8E9F0] rounded-[20px] px-6 py-10 text-center">
            <img
              src={caseNoteIcon}
              alt="Case Review"
              className="mx-auto mb-4 w-[48px]"
            />
            <h3 className="text-[18px] font-bold text-[#162766] mb-2">
              Case Review
            </h3>
            <p className="text-[14px] leading-[20px] text-[#162766]">
              Share your details, and we will check whether you qualify.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#E8E9F0] rounded-[20px] px-6 py-8 text-center">
            <img
              src={attorneyCallIcon}
              alt="Attorney Connection"
              className="mx-auto mb-4 w-[48px]"
            />
            <h3 className="text-[18px] font-bold text-[#162766] mb-2">
              Attorney Connection
            </h3>
            <p className="text-[14px] leading-[20px] text-[#162766]">
              Get matched with experienced Ozempic lawyers.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#E8E9F0] rounded-[20px] px-6 py-8 text-center">
            <img
              src={compensationIcon}
              alt="Compensation Pursuit"
              className="mx-auto mb-4 w-[48px]"
            />
            <h3 className="text-[18px] font-bold text-[#162766] mb-2">
              Compensation Pursuit
            </h3>
            <p className="text-[14px] leading-[20px] text-[#162766]">
              Your attorney files your case and fights for maximum recovery.
            </p>
          </div>
        </div>
      </section>

      {/* ================= MOBILE FOOTER CTA ================= */}
      <section className="md:hidden w-full bg-[#162B6F] py-10">
        <div className="px-5 text-center">
          <h2 className="text-[20px] leading-[26px] font-semibold text-white mb-3">
            Ready To Get a Free
            <br />
            Ozempic Lawsuit <br />
            Case Review?
          </h2>

          <div className="w-[32px] h-[2px] bg-[#F8D216] mx-auto mb-4" />

          <p className="text-[14px] leading-[22px] text-white/90 mb-7">
            Contact our legal partners today.
          </p>

          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="
              w-full
              h-[46px]
              bg-[#F9D51C]
              text-[#0E1E4D]
              text-[14px]
              font-extrabold
              tracking-widest
              rounded-[8px]
            "
          >
            GET HELP NOW
          </button>
        </div>
      </section>
    </div>
    </div>
  );
};

export default NewMedicalOzempicLawsuitB;
